import * as React from 'react'
import { Alert } from '../../../ui/alert'

interface Props {
    message?: {
        args: {
            ct: number
        }
    }
}

export default class Shopware6RepeatedCartPersisterSave extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let intro = (
            <p>
                We observed Traces making calls to <code>Shopware\Core\Checkout\Cart\CartPersister::save</code> more than once per request.
            </p>
        )

        if (message) {
            const { args } = message

            intro = (
                <p>
                    This trace called <code>Shopware\Core\Checkout\Cart\CartPersister::save</code>
                    <strong>{args.ct}</strong> times.
                </p>
            )
        }

        return (
            <div>
                {intro}
                <p>
                    Saving the cart multiple times in a request is considered a performance bottleneck because the save operation is
                    expensive. You should make all the required changes and then only save once at the end.
                </p>

                <Alert level="warning">
                    <p>
                        Up to Shopware 6.6.6.0 there was a bug in <code>CartRuleLoader</code> that led to multiple calls to
                        <code>CartPersister::save</code> when the cart has errors. This was fixed in{' '}
                        <a href="https://github.com/shopware/shopware/commit/ca65dc3a3121c4728726255fb9517718a99491c0">
                            in this Shopware Core commit
                        </a>
                        . This can cause very slow requests to &quot;Add Item to Cart&quot; action initiated by bots crawling the store.
                    </p>
                </Alert>
            </div>
        )
    }
}
